import { qs, bounds } from "../utils"

export default class Component {
  constructor(obj) {
    this.el = obj.el || null
    this.renderer = obj.renderer || null
    const id = obj.index || 0
    const data = obj.data || null

    // How the component has to behave
    this.hasTick = data.hasTick || false
    this.hasAnimateIn = data.hasAnimateIn || false
    this.hasAnimateOut = data.hasAnimateOut || false
    this.hasAnimateOnScroll = data.hasAnimateOnScroll || false
    if (this.el) this.rect = bounds(this.el)
  }

  setup() {
    if (!this.name) return
    this.el = qs(`[data-${this.name}]`)
  }

  animateIn() {}

  animateOut() {}

  animateOnScroll() {}

  tick(obj) {}

  resize() {}

  smoothResize() {}

  on() {}

  off() {}

  destroy() {
    this.off()
  }

  setWebgl() {}

  render() {
    this.setup()
    this.on()
    this.hasAnimateOnScroll && this.animateOnScroll()
  }
}
